import { getWebsite } from '@va/dashboard/selectors/core';
import { SubscriptionTypeEnum } from '@va/standalone/shared/constants';
import { BusinessInfoType } from '@va/types/account';
import { WixOnboardingStepsEnum } from '@va/wix/shared/constants';
import { createSelector } from 'reselect';

export const isMigrationEmailSent = (state: any) => state.getIn(['app', 'isMigrationEmailSent'], false);

export const getMetaSiteId = createSelector([getWebsite], (website) => {
  return website.metaSiteId;
});

export const getPremiumPlans = (state: any) => state.getIn(['app', 'premiumPlan']).toJS();

export const getInitialUpgradePlanId = (state: any) =>
  state.getIn(['app', 'initialUpgradePlanId'], undefined) as string | undefined;

export const getInitialUpgradePlanSubscriptionType = (state: any) =>
  state.getIn(['app', 'initialUpgradePlanSubscriptionType'], undefined) as SubscriptionTypeEnum | undefined;

export const getInitialOnboardingStep = (state: any) =>
  state.getIn(['app', 'initialOnboardingStep'], undefined) as WixOnboardingStepsEnum | undefined;

export const getBusinessInfo = createSelector([getWebsite], (website) => {
  return {
    businessSector: website?.businessSector ?? '',
    businessType: website?.businessType ?? '',
    businessSize: website?.businessSize ?? '',
    city: website?.city ?? '',
    country: website?.country ?? '',
    companyName: website?.companyName ?? '',
    companyWebsite: website?.companyWebsite ?? '',
    firstName: website?.firstName ?? '',
    lastName: website?.lastName ?? '',
    state: website?.state ?? '',
    street: website?.street ?? '',
    vat: website?.vat ?? '',
    zipcode: website?.zipcode ?? '',
  } as BusinessInfoType;
});

export const isBusinessInfoCompleted = createSelector([getBusinessInfo], (businessInfo) => {
  return Object.values(businessInfo).every((value) => !!value);
});
